var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"b1",class:_vm.context.classes.label,style:(_vm.labelStyle),attrs:{"id":`${_vm.context.id}_label`,"for":_vm.context.id}},[_vm._v(" "+_vm._s(_vm.context.label)+" "),(_vm.required)?_c('b',[_vm._v("*")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }